import { useTranslation } from 'react-i18next'

import { CopySimpleIcon } from 'assets/icons/settings'

import { useNotifications } from 'app/application/application'

import styles from './ApiKeys.module.scss'

interface CredentialFieldProps {
  copyLabel: string
  description: string
  label: string
  value: string
}

const CredentialField = ({ copyLabel, description, label, value }: CredentialFieldProps) => {
  const { t } = useTranslation('settings')
  const { createNotification } = useNotifications()

  const copyValue = () => {
    void navigator.clipboard.writeText(value).then(() =>
      createNotification({
        message: t('access.copySuccessful.message', { value: label }),
        title: t('access.copySuccessful.title'),
        type: 'success',
      }),
    )
  }

  return (
    <div className={styles.field}>
      <div className={styles.labelGroup}>
        <div>{label}</div>
        <div>{description}</div>
      </div>
      <button aria-label={copyLabel} className={styles.value} onClick={copyValue} type="button">
        <span>{value}</span>
        <CopySimpleIcon />
      </button>
    </div>
  )
}
export default CredentialField
